import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { Avatar } from "./UserAvatarView.styles";
import { colors } from "healthex-common/colors";
import { filterNull, willNeverHappen } from "healthex-common/utils";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
export var UserAvatarViewSize;
(function (UserAvatarViewSize) {
    UserAvatarViewSize["TINY"] = "TINY";
    UserAvatarViewSize["SMALL"] = "SMALL";
    UserAvatarViewSize["MEDIUM"] = "MEDIUM";
    UserAvatarViewSize["LARGE"] = "LARGE";
    UserAvatarViewSize["PROFILE"] = "PROFILE";
    UserAvatarViewSize["PROFILE_BANNER"] = "PROFILE_BANNER";
})(UserAvatarViewSize || (UserAvatarViewSize = {}));
export const UserAvatarView = observer((props) => {
    var _a, _b, _c, _d;
    const sizeInfo = getSizeInfo((_a = props.size) !== null && _a !== void 0 ? _a : UserAvatarViewSize.SMALL);
    const localAvatarFile = (_b = props.user) === null || _b === void 0 ? void 0 : _b.localAvatarFile;
    const localAvatarUrl = React.useMemo(() => (localAvatarFile ? URL.createObjectURL(localAvatarFile) : null), [localAvatarFile]);
    React.useEffect(() => {
        return () => {
            if (localAvatarUrl)
                URL.revokeObjectURL(localAvatarUrl);
        };
    }, [localAvatarUrl]);
    const avatarSrc = (_d = localAvatarUrl !== null && localAvatarUrl !== void 0 ? localAvatarUrl : (_c = props.user) === null || _c === void 0 ? void 0 : _c.avatarUrl) !== null && _d !== void 0 ? _d : undefined;
    return (_jsx(Avatar, { src: avatarSrc, width: sizeInfo.width, height: sizeInfo.height, fontSize: sizeInfo.fontSize, color: props.user ? avatarColor(props.user) : "", onClick: props.onClick, disabled: props.disabled, borderRadius: sizeInfo.borderRadius, fontWeight: sizeInfo.fontWeight, "$hasImage": !!avatarSrc, children: props.user && getUserInitials(props.user) }));
    function avatarColor(user) {
        if (props.disabled)
            return colors.black_30;
        const accentColors = [colors.accents_sunset, colors.accents_salmon, colors.accents_grass, colors.accents_sky, colors.accents_lilac];
        return accentColors[Number(`0x${user.id.slice(-2)}`) % accentColors.length];
    }
    function getUserInitials(user) {
        const parts = filterNull([user.firstName, user.lastName]);
        if (parts.length === 0) {
            return null;
        }
        else if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        else {
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }
    }
    function getSizeInfo(size) {
        switch (size) {
            case UserAvatarViewSize.TINY:
                return { width: 24, height: 24, fontSize: fontSizes.TINY };
            case UserAvatarViewSize.SMALL:
                return { width: 32, height: 32, fontSize: fontSizes.SMALL };
            case UserAvatarViewSize.MEDIUM:
                return { width: 40, height: 40, fontSize: fontSizes.MEDIUM };
            case UserAvatarViewSize.LARGE:
                return { width: 80, height: 80, fontSize: fontSizes.LARGE };
            case UserAvatarViewSize.PROFILE:
                return { width: 96, height: 96, fontSize: fontSizes.SUPER };
            case UserAvatarViewSize.PROFILE_BANNER:
                return {
                    width: 52,
                    height: 64,
                    fontSize: fontSizes.LARGE,
                    borderRadius: "12px",
                    fontWeight: fontWeights.BOLD,
                };
        }
        return willNeverHappen(size);
    }
});
